import classNames from 'classnames'
import DropdownImage from './DropdownImage'

const DropdownItem = (props) => {
  const { customClass, href, onClick, title, variant, value, image } = props
  const classes = classNames(
    variant ? 'control-dropdown__item--' + variant : '',
    image ? 'control-dropdown__item--with_image' : '',
    customClass
  )

  return (
    <a
      class={classes}
      href={href}
      onClick={onClick}
      value={value}
    >
      {image && <DropdownImage image={image} />}
      {title}
    </a>
  )
}

export default DropdownItem
